var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppTableRow',_vm._b({ref:"tableRow",class:{
    border: _vm.source.is_parent,
    'border-dashed': _vm.source.is_parent,
    'border-dark': _vm.source.is_parent,
  },staticStyle:{"--row-h":"4rem"},attrs:{"source":_vm.source},on:{"showMenu":_vm.showMenu},scopedSlots:_vm._u([{key:"name",fn:function(ref){
  var ref_source = ref.source;
  var name = ref_source.name;
  var code = ref_source.code;
return [_c('div',{staticClass:"flex flex-row items-center text-dark"},[_c('Icon',{staticClass:"w-6 h-6 mr-2",staticStyle:{"min-width":"1.5rem"},attrs:{"icon":_vm._f("l0IconByCode")(code)}}),_c('p',{staticClass:"text-lg pr-2 single-line",attrs:{"title":name}},[_vm._v(_vm._s(name))])],1)]}},{key:"count",fn:function(ref){
  var count = ref.source.count;
return [_c('button',{staticClass:"text-lg text-primary font-medium pl-2 text-left",on:{"click":_vm.onCountClick}},[_vm._v(" "+_vm._s(count)+" ")])]}},{key:"startDate",fn:function(ref){
  var startDate = ref.source.startDate;
return [_c('p',{staticClass:"text-lg text-dark single-line"},[_vm._v(" "+_vm._s(_vm._f("date")(startDate,"ll - hh:mm A"))+" ")])]}},{key:"endDate",fn:function(ref){
  var endDate = ref.source.endDate;
return [_c('p',{staticClass:"text-lg text-dark single-line"},[_vm._v(" "+_vm._s(_vm._f("date")(endDate,"ll - hh:mm A"))+" ")])]}}])},'AppTableRow',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }